import React, { Dispatch, SetStateAction, useState } from 'react'
import {
  Col,
  DatePicker,
  Form,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-angle-dashboard-components'
import { FormLabel, FormControl } from '../styles'
import styled from 'styled-components'

const HelpIcon = styled.i`
  color: var(--gray-400);
  height: 10px;
  width: 10px;
  position: relative;
  top: 0px;
  left: 4px;
`

export const MemberSearch: React.FC<{
  formData: any
  setFormData: Dispatch<SetStateAction<any>>
}> = ({ formData, setFormData }) => {
  const [memberIdError, setMemberIdError] = useState(false)

  let namesShowFlag = true

  if (formData?.memberId && formData.memberId.length === 9) {
    namesShowFlag = false
  }

  return (
    <>
      <Form.Group className="pb-3">
        <FormLabel>Billed Amount</FormLabel>
        <FormControl
          required
          placeholder="Enter a valid amount"
          value={formData.billedAmount}
          onChange={(e: any) => {
            const val = e.target.value.replace(/[^\d.]/g, '')
            setFormData((prevState: any) => ({
              ...prevState,
              billedAmount: val
            }))
          }}
        />
      </Form.Group>
      <Form.Group className="pb-3">
        <FormLabel>Angle Member ID</FormLabel>
        <InputGroup>
          <InputGroup.Text>ANG</InputGroup.Text>
          <FormControl
            placeholder="Please enter the member ID number"
            required
            maxLength={9}
            value={formData.memberId}
            isInvalid={memberIdError}
            onChange={(e: any) => {
              setMemberIdError(e.target.value.toLowerCase().includes('ang'))
              setFormData((prevState: any) => ({
                ...prevState,
                memberId: e.target.value
              }))
            }}
          />
        </InputGroup>
      </Form.Group>
      { namesShowFlag && 
      (<Row>
        <Col sm={6} xs={12}>
          <Form.Group className="pb-3">
            <FormLabel>First Name</FormLabel>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  data-testid="about-tooltip"
                  id="reconsideration tooltip"
                >
                  Please use the exact spelling of the member's name,
                  including special characters and spaces
                </Tooltip>
              }
            >
              <HelpIcon
                data-testid="about-tooltip-trigger"
                className="icon icon-question-mark fs-12"
              />
            </OverlayTrigger>
            <FormControl
              required
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e: any) =>
                setFormData((prevState: any) => ({
                  ...prevState,
                  firstName: e.target.value
                }))
              }
            />
          </Form.Group>
        </Col>
        <Col sm={6} xs={12}>
          <Form.Group>
            <FormLabel>Last Name</FormLabel>
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  data-testid="about-tooltip"
                  id="reconsideration tooltip"
                >
                  Please use the exact spelling of the member's name,
                  including special characters and spaces
                </Tooltip>
              }
            >
              <HelpIcon
                data-testid="about-tooltip-trigger"
                className="icon icon-question-mark fs-12"
              />
            </OverlayTrigger>
            <FormControl
              required
              placeholder="Last Name"
              value={formData.lastName}
              onChange={(e: any) =>
                setFormData((prevState: any) => ({
                  ...prevState,
                  lastName: e.target.value
                }))
              }
            />
          </Form.Group>
        </Col>
      </Row>)
      }
      <Form.Group className="pb-3">
        <FormLabel className="pb-3">Member's Date of Birth</FormLabel>
        <DatePicker
          value={formData.dateOfBirth}
          required
          onChange={(date) =>
            setFormData((prevState: any) => {
              return {
                ...prevState,
                dateOfBirth: date
              }
            })
          }
        />
      </Form.Group>
    </>
  )
}
